<!DOCTYPE html>
<html lang="en">

<body>
  <header *ngIf="!mobView">
    <div class="topStrip">
      <div class="container-xl">
        <div class="row">
          <div class="col-md-12">
            <div class="topband">
              <div class="leftMenuTop">
                <ul>
                  <li><a routerLink="/" title="Home">{{ 'HOME' | translate }}</a></li>
                  <li><a routerLink="/sitemap" title="sitemap">{{ 'SITEMAP' | translate }}</a></li>
                  <!-- <li><a routerLink="/feedback" title="feedback">Feedback</a></li> -->
                </ul>
              </div>
              <div class="rightTopStrip">
                <div id="zoomable-element" [style.transform]="'scale(' + zoomLevel + ')'">
                  <!-- Your zoomable content goes here -->
                </div>
                <!-- <button id="zoom-in" (click)="zoom('zoom-in')">Zoom In</button>
                <button id="zoom-out" (click)="zoom('zoom-out')">Zoom Out</button>
                <button id="zoom-auto" (click)="zoom('reset')">Reset Zoom</button> -->
                <ul class="smallFont">
                  <li><a href="#skipContent" class="skipContent" accesskey="s" title="Skip to Main Content">{{ 'Skip to
                      Main Content' | translate }}</a></li>
                  <li><a routerLink="/screen-reader-access" title="Screen Reader Access">{{ 'Screen Reader Access' |
                      translate }}</a></li>
                  <li class="fontResize">
                    <div id="accessControl" class="textResizeWrapper">
                      <div class="fontResizeInfo">
                        <input type="button" name="font_large" value="T+" id="zoom-in" (click)="zoom('zoom-in')"
                          title="Large Font Size" class="fontScaler large font-larger">
                        <input type="button" name="font_normal" value="T" id="zoom-auto" (click)="zoom('reset')"
                          title="Normal Font Size" class="fontScaler normal font-normal">
                        <input type="button" name="font_small" value="T-" id="zoom-out" (click)="zoom('zoom-out')"
                          title="Small Font Size" class="fontScaler font-large">
                      </div>
                      <input type="button" name="normal" value="" id="normal" title="Standard View"
                        class="contrastChanger normal current">
                      <input type="button" name="wob" value="" id="wob" title="High Contrast View"
                        class="contrastChanger wob">
                    </div>
                  </li>
                  <!-- <li class="language">
                    <label for="lang" class="d-none">{{ 'LANGUAGE' | translate }}</label>
                    <select (change)="switchLanguage($event)">
                      <option *ngFor="let lang of supportedLanguages" [value]="lang.code">
                        {{ lang.name }}
                      </option>
                    </select>
                  </li> -->
                  <li class="language">
                    <div class="bhashini-plugin-container"></div>
                  </li>

                  <!-- <li>
                    <div>
                    <div class="bhashini-plugin-container">
                    <div class="dont-translate bhashini-skip-translation bhashini-dropdown" id="bhashini-translation"
                    title="Translate this page!">
                    <button class="bhashini-dropdown-btn">
                    <div class="bhashini-dropdown-btn-icon"> </div>
                    </button>
                    <div class="bhashini-dropdown-content" id="bhashiniLanguageDropdown"
                    style="display: none; top: 100%; bottom: auto;">
                    <script src="https://translation-plugin.bhashini.co.in/v2/website_translation_utility.js" data-pos-x="93"
                    data-pos-y="98.5"></script>
                    </div>
                    </div>
                    </div>
                    </div>
                    </li> -->


                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="headerRow">
      <div class="container-xl">
        <div class="row">
          <div class="col-md-8">
            <h1 class="logo"><a routerLink="/" title="Logo"> <img src="assets/images/logo.png" alt="Logo"> </a></h1>
          </div>
          <div class="col-md-4">
            <div class="headerRowRight">
              <div class="row">
                <div class="cyberheader">
                  <ul>
                    <!-- <li><a routerLink="/registration" title="Apply For UDID">{{ 'Apply For UDID' | translate }} </a></li> -->

                    <li *ngIf="!user">
                      <a routerLink="/login" class="cyberbtn" title="PwD login"><img src="assets/images/login.svg"
                          alt="login" /> {{ 'PwD login' | translate }}</a>
                    </li>
                    <li *ngIf="user">
                      <a class="cyberbtn" routerLink="/dashboard/my-account" title="Dashboard">{{ 'Dashboard' |
                        translate }} </a>
                    </li>
                    <li *ngIf="user">
                      <a class="cyberbtn" title="Logout" (click)="fLogout()"><img src="assets/images/login.svg"
                          alt="Logout" /> {{ 'Logout' | translate }} </a>
                    </li>
                    <li><a href="{{adminUrl}}" title="Department User Login " target="_blank"><img
                          src="assets/images/user-plus.svg" alt="login" />
                        {{ 'Department User Login' | translate }} </a></li>
                  </ul>
                </div>
                <div class="open-search">
                  <div class="sideBarBtn">
                    <button class="hamburger btn p-0" type="button" id="slide">
                      <img src="assets/images/toggle-menu.png" alt="icon" title="icon" width="27" class="img-fluid">
                    </button>
                  </div>
                  <div class="searchContainer">
                    <div class="searchBtn"><img src="assets/images/search.png" alt="search"></div>
                    <div class="searchBox">
                      <label accesskey="f" class="d-none" for="search"> {{ 'search' | translate }}</label>
                      <input type="text" id="search" name="search">
                    </div>
                  </div>
                </div>
                <div class="headerSideBar">
                  <div class="menuMobileRight">
                    <div class="offcanvas-body p-0">
                      <button type="button" class="btn-close"><span class="d-none"> {{ 'close' | translate
                          }}</span></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="headermenu">
      <div class="container-xl">
        <div class="row">
          <div id="mainNav" class="mainNavigation">
            <div class="menuPart cf">
              <ul id="nav">
                <li><a routerLink="/" title="Home" accesskey="h"><img src="assets/images/home-icons.png"
                      alt="home-icons"></a></li>
                <!-- <li> <a routerLink="/about-us" title="About us">About Us</a>
                  <ul>
                    <li><a routerLink="/contact" title="Contact Us">Contact Us </a></li>
                    <li><a href="#">Know more about UDID</a></li>
                    <li><a href="#">Schemes for Persons with Disabilities</a></li>
                    <li><a href="#">About Department of Empowerment of Persons with Disabilities</a></li>
                  </ul>
                </li> -->
                <!-- <li><a href="card-benefits" title="Card Benefits">Card Benefits</a></li> -->
                <!-- <li><a href="#" title="About Persons with Disabilities">About Persons with Disabilities</a></li> -->
                <!-- <li><a routerLink="/registration" title="Apply For UDID">{{ 'Apply For UDID' | translate }}</a></li> -->
                <li><a routerLink="/Applyforudid" title="Apply For UDID">{{ 'Apply For UDID' | translate }} </a></li>
                <li class="rightmenu"><a routerLink="/track-your-application" title="Track Your Application">{{ 'Track
                    Your Application' | translate }}</a></li>
                <li *ngIf="!user"><a routerLink="/login" title="PwD login">{{ 'PwD login' | translate }}</a></li>
                <!-- <li><a href="{{adminUrl}}" title="Department User Login" target="_blank" >{{ 'Department User Login' | translate }}</a></li> -->
                <li><a routerLink="/dashboardchart" title="Aggregated Data">{{'Aggregated-Data' | translate}}</a></li>
                <!-- <li><a  routerLink="/aggregated-data" title="Aggregated Data">{{ 'Aggregated Data' | translate }}</a> </li> -->
                <li><a routerLink="/Pendencyreport" title="Pendency Report">{{ 'Pendency-Report' | translate }} </a>
                </li>
                <li><a routerLink="/statewisereport" title="/Statewise-Report">{{ 'Statewise-Report' | translate }} </a>
                </li>
                <li>
                  <a href="javascript:void(0)" title="Data wrapper">Data wrapper</a>
                  <ul>
                    <li><a routerLink="/dashboardbarchart" title="Dashboard Bar">Total Cards Generated </a></li>


                    <li><a routerLink="/Pendencyreportbarchart" title="Pendency Bar">Total Pendency </a></li>
                    <li><a routerLink="/statewisereportbarchart" title="Generated Udid Card Bar">State wise Report</a>
                    </li>

                  </ul>
                </li>

                <!-- <li><a  routerLink="/aggrigate" title="Aggregated Data">{{ 'Aggregated Data' | translate }}</a> </li>-->


                <!-- <ul>
                  <li><a routerLink="/state" title="State">State </a></li>
                  <li><a routerLink="/district" title="District">District</a></li>
                  <li><a routerLink="/sub-district" title="Sub-District">Sub-District</a></li>
                </ul> -->

                <li><a href="javascript:void(0)" title="Media ">{{ 'Media' | translate }} </a>
                  <ul>
                    <!-- <li><a href="#" title="Success Stories">Success Stories</a></li> -->
                    <li><a routerLink="/photo-gallery" title="Photo Gallery">{{ 'Photo Gallery' | translate }}</a></li>
                    <li><a routerLink="/video-gallery" title="Video Gallery">{{ 'Video Gallery' | translate }}</a></li>
                    <!-- <li><a href="#" title="Press Release">Media Gallery</a></li> -->
                    <!-- <li><a href="#" title="Circulars">Circulars</a></li> -->

                  </ul>
                </li>


                <!-- <li><a href="#" title="Suggestions & FAQs">Suggestions & FAQs</a></li> -->
                <li class="rightmenu"><a routerLink="/faqs" title="FAQs">{{ 'FAQs' | translate }}</a>
                  <!-- <ul>
                    <li><a routerLink="/about-persons-with-disability" title="About Persons With Disability">{{ 'About Persons With Disability' | translate }} </a></li>
           
                  </ul> -->
                </li>
                <li><a routerLink="/feedback" title="Contact Us">{{ 'Contact Us' | translate }} </a></li>

              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</body>

</html>